import { dateFormatter } from 'zens-storybook'

import { ProfileStatus } from '../auth'
import { Model } from '../general'
import { I18nStore } from '../i18n'

interface RootStore {
  i18n: I18nStore
}

export interface Data {
  id: number
  name?: string
  email?: string
  status?: number
  role_id?: number
  location_id?: number
  created_at?: string
}

class User extends Model<Data, RootStore> {
  get email() {
    return this.data.email
  }

  get displayName() {
    const words = `${this.data.name || ''}`.split(' ')
    return words
      .map((word, index) =>
        index === 0 || index === words.length - 1
          ? word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()
          : word,
      )
      .join(' ')
  }

  get displayCreatedAt() {
    const { i18n } = this.store
    return this.data.created_at ? dateFormatter(this.data.created_at, 'PPP', i18n.language) : ''
  }
  get status() {
    switch (this.data.status) {
      case 0:
        return ProfileStatus.Invited
      case 1:
        return ProfileStatus.Active
      default:
        return ProfileStatus.Unknown
    }
  }

  get locationId() {
    return this.data.location_id
  }

  get roleId() {
    return this.data.role_id
  }

  set roleId(roleId: number | undefined) {
    this.data.role_id = roleId
  }

  get searchText(): string {
    return `${this.displayName}${this.email}`
  }
}

export default User
